import(/* webpackMode: "eager" */ "/opt/meet/app/auth-telegram/auth/page.tsx");
